import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SharedKnowledgeState} from './knowledge.state';
import {KnowledgePathStartDto} from '@server-models';

export const sharedKnowledgeStoreSelect =
  createFeatureSelector<SharedKnowledgeState>('sharedKnowledge');

export const selectKnowledgePathList = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.items
);

export const selectKnowledgePathPagination = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.paging
);

export const selectKnowledgeActiveSummary = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.activeSummary
);

export const selectKnowledgePathStart = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.activePath
);

export const selectArticlesPathStart = createSelector(
  selectKnowledgePathStart,
  (pathStart: KnowledgePathStartDto) => pathStart.articles
)

export const selectKnowledgePathModel = createSelector(
  selectKnowledgePathStart,
  (model: KnowledgePathStartDto) => model
)

export const selectKnowledgeActiveExam = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.activeExam
)


export const selectKnowledgePathLoading = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.isLoading
);

export const selectArticlePage = createSelector(
  sharedKnowledgeStoreSelect,
  (state: SharedKnowledgeState) => state.activeArticle
);
